import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { clearRedirect, readRedirect } from '@/lib/redirectStorage'

/**
 * ログイン/登録後の戻り先を一度だけ確定して返す。
 *
 * 優先順位: location.state.from（SPA内遷移） > sessionStorage（保険） > '/'。
 * マウント時に確定値を捕捉し（読み取りのみ＝レンダー純粋）、確定後は sessionStorage を
 * クリアして「読んだら消す」とし、残留値による次回ログインの誤遷移を防ぐ（クリアは effect）。
 */
export function useRedirectTarget(): string {
  const location = useLocation()
  const [target] = useState(
    () =>
      (location.state as { from?: string } | null)?.from
      ?? readRedirect()
      ?? '/',
  )

  useEffect(() => {
    clearRedirect()
  }, [])

  return target
}
